import { Route, Routes } from 'react-router-dom';

import Subscriptions from './Subscriptions';

const SubscriptionsView = () => {
  return (
    <Routes>
      <Route path="/" element={<Subscriptions />} />
    </Routes>
  );
};

export default SubscriptionsView;
